export default "__VITE_ASSET__F$ggKNEt__"